<template>
    <div>
        <div class="filterbox">
            <div class="filtertxt">
                <div style="width:100%;margin-bottom:32px;">
                    <span style='margin-right:47px;' class="labeltxt"> 帐号</span>
                    <Input v-model="fileterObj.user_name" placeholder="" style="max-width:19%;" @on-keyup.enter="filter"/>
                    <span style='margin-right:45px;margin-left:45px;' class="labeltxt"> 姓名</span>
                    <Input v-model="fileterObj.realname" placeholder="" style="max-width:19%;" @on-keyup.enter="filter"/>
                    <span style='margin-right:20px;margin-left:40px;' class="labeltxt"> 所属企业</span>
                    <Input v-model="fileterObj.org_name" placeholder="" style="max-width:19%;" @on-keyup.enter="filter"/>
                </div>
                <div style="width:100%;margin-bottom:32px;">
                    <span style='margin-right:17px;' class="labeltxt"> 所属门店</span>
                    <Input v-model="fileterObj.store_name" placeholder="" style="max-width:19%;" @on-keyup.enter="filter"/>
                    <span style='margin-right:44px;margin-left:51px;' class="labeltxt">角色</span>
                    <Select v-model="fileterObj.role_id" style="max-width:19%;" @on-change="filter">
                        <Option v-for="item in rolelist" :value="item.roleId" :key="item.roleId">{{ item.roleName }}</Option>
                    </Select>
                    <span style='margin-right:21px;margin-left:40px;' class="labeltxt"> 注册日期</span>
                    <DatePicker type="daterange" placeholder="请输入日期范围" split-panels style="width:19%;" @on-change="timechange"></DatePicker>

                </div>
                <div style="width:100%;">
                    
                    
                    
                </div>
            </div>
            <div class="filterbtn">
                <button @click="filter">
                    查询
                </button>
            </div>
        </div>
        <div style="height:31px;background:#eff0f8;">
        </div>
        <div class="listbox company_manage">
            <button class="creatbtn" @click="tocreat(1)" v-hasbtn="'/accountmanagement/creat'" style="margin-right:20px;">
                    + 新建帐号
            </button>
            <button class="creatbtn" @click="tocreat(2)" v-hasbtn="'/accountmanagement/othercreat'">
                    + 新建独立经纪人
            </button>
            <div :style="data1.length==0?'':'min-height:calc(100vh - 680px)'">
                <Table stripe :columns="columns1" :data="data1" disabled-hover:no-data-text="''"></Table>
            </div>
            <div style="text-align: center;padding: 66px 0;" v-show="data1.length==0">
                <p><img src="@/assets/img/nomessage.png"></p>
                <h1 style="font-size: 16px;padding: 10px 0;color:#101d37">未查询到相关数据</h1>
            </div>
            <div  style="margin-top:20px;">
                <div slot style="display: inline-block;line-height: 30px;color:#9f9f9f">
                        共 {{total}} 条记录  第 {{fileterObj.pageNo}}/{{allpage}} 页         
                </div>
                <Page ref="pages" :total="total" show-elevator :page-size="fileterObj.pageSize"  @on-change="pagechange">
                </Page>
            </div>
                
        </div>
        <Modal
        v-model="ResetModel"
        title="提示!"
        @on-ok="Resetok"
        @on-cancel="ResetModel=false;chooseId='';">
        <p>密码将重置为六个1，是否确认?</p>
    </Modal> 

     <Modal
        v-model="stopModel"
        title="提示!"
        @on-ok="stopok"
        @on-cancel="stopModel=false;chooseId='';chooseName='';roleCode='';">
        <p>确认{{itemstastu==1?'停用':'启用'}}帐号?</p>
    </Modal> 
    </div>
</template>
<script>
import { admin } from '@/api/admin'
import { hasbtn } from '@/utils/commondata'
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    data(){
        return{
            total:100,
            allpage:10,
            fileterObj:{
                user_status:'1',
                pageNo:1,
                pageSize:10,
                user_name:''
            },
            ResetModel:false,
            stopModel:false,
            chooseId:'',
            chooseName:'',
            roleCode:'',
            itemstastu:'',
            rolelist:[],
            columns1: [
                    {
                        title: ' ',
                        align:'center',
                        width:60,
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    }
                                }, params.index+1)
                            ]    
                        } 
                    },
                    {
                        title: '帐号',
                        align:'center',
                        key: 'userName',  
                    },
                    {
                        title: '姓名',
                        align:'center',
                        key: 'realname',
                        render : (h, params) => {
                            if(hasbtn(this.$router.options.routes[1].children,'/accountmanagement/infor')){
                                return [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style: {
                                            color: '#3569fd',
                                            fontSize:'14px',
                                        },
                                        on: {
                                            click: () => {
                                                this.$router.push({path:'/accountmanagement/infor',query:{id:params.row.userId,roleCode:params.row.roleCode}})
                                            }
                                        }
                                    }, params.row.realname?params.row.realname:'--')
                                ] 
                            }else{
                                return[
                                    h('div', {
                                    
                                        }, params.row.realname?params.row.realname:'--') 
                                ]
                                        
                            }
                               
                        } 
                    },
                    {
                        title: '联系电话',
                        align:'center',
                        key: 'phone',
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.phone?params.row.phone:'--')
                            ]    
                        }
                    },
                    {
                        title: '所属机构',
                        align:'center',
                        key: 'orgName',
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.orgName?params.row.orgName:'--')
                            ]    
                        }
                    },
                    {
                        title: '所属门店',
                        align:'center',
                        key: 'storeName',
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.storeName?params.row.storeName:'--')
                            ]    
                        }
                    },
                    {
                        title: '角色',
                        align:'center',
                        key: 'roleName',
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.roleName?params.row.roleName:'--')
                            ]    
                        }
                    },
                    {
                        title: '注册日期',
                        align:'center',
                        key: 'createDate',
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.createDate.split(' ')[0])
                            ]    
                        }
                    },
                    {
                        title: '操作',
                        key: 'sale',
                        width:'200',
                        align:'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        color: '#3569fd',
                                        fontSize:'14px',
                                    },
                                    on: {
                                        click: () => {
                                            this.chooseId=params.row.userId;
                                            this.ResetModel=true;
                                        }
                                    }
                                }, '重置密码'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        color: '#afafaf',
                                        fontSize:'14px',
                                    },
                                    on: {
                                        click: () => {
                                            this.chooseId=params.row.userId;
                                            this.chooseName=params.row.userName;
                                            this.roleCode=params.row.roleCode;
                                            this.itemstastu=params.row.userStatus;
                                            this.stopModel=true;
                                        }
                                    }
                                }, params.row.userStatus=='1'?'停用':'启用')
                            ])
                        }
                    }            
                ],
                data1: [ ]
            
        }
    },
    mounted(){
        this.getrolelist();
        if(this.$route.query.storeName){
            this.fileterObj.store_name=this.$route.query.storeName;
        }
        this.getlist();
    },
    methods:{
        getrolelist(){
            admin.getroleselect().then(res=>{
                if(res.data.success==true){
                    res.data.result=[{roleId:'',roleName:'全部'}].concat(res.data.result);
                    this.rolelist=res.data.result;
                    
                }
            })
        },
        tocreat(num){
            if(num==1){
                this.$router.push('/accountmanagement/creat');
            }else{
                this.$router.push('/accountmanagement/othercreat');
            }
            
        },
        pagechange(n){
            this.fileterObj.pageNo=n;
            this.getlist();
        },
        filter(){
            this.fileterObj.pageNo=1;
            this.$refs['pages'].currentPage = 1;
            this.getlist();
        },
        timechange(val){
            this.fileterObj.reg_time_s=val[0];
            this.fileterObj.reg_time_e=val[1];
            this.filter();
        },
        getlist(){
            admin.getaccountlist(this.fileterObj).then(res=>{
                if(res.data.success==true){
                    this.data1=res.data.result.records;
                    this.total=res.data.result.total;
                    this.allpage=res.data.result.pages?res.data.result.pages:1
                }
            })
        },
        Resetok(){
            admin.repassword(this.chooseId).then(res=>{
                this.$Message.success(res.data.message);
                this.getlist();
            })
            
        },
        stopok(){
            let status=this.itemstastu==1?'2':'1';
            admin.userFrozen(this.chooseId,this.chooseName,status,this.roleCode).then(res=>{
                if(res.data.success==true){
                    this.$Message.success(res.data.message);
                    this.getlist();
                }else{
                    this.$Message.error(res.data.message);
                }    
            })
        }
    }
}
</script>

<style scoped>
    .filterbox{
        height: 180px;
        box-sizing: border-box;
        padding: 40px 60px 40px 40px;
        background-color: #ffffff;
        box-shadow: 0px 0px 21px 0px 
            rgba(191, 199, 221, 0.26);
        border-radius: 4px;
    }
    .filtertxt{
        width:80%;
        display: inline-block;
        vertical-align: middle;
        float:left;
    }
    .labeltxt{
        color: #101d37;
        font-size: 14px;
    }
    .filterbtn{
        width:19%;
        display: inline-block;
        text-align: right;
        /* padding-right: 60px; */
        vertical-align: middle;
        margin-top: 26px;
    }
    .filterbtn button{
        border: none;
        color: #ffffff;
        width: 132px;
        height: 42px;
        background-color: #26ce95;
        box-shadow: 0px 4px 6px 0px
            rgba(38, 206, 149, 0.22);
        border-radius: 3px;
        line-height: 42px;
        
    }
    .listbox{
       padding: 20px 23px 33px 30px;
    }
    .typeclass{
        margin-bottom:10px;
    }
    .typeclass span{
        margin-right: 20px;
        cursor: pointer;
    }
    span.active{
        color: #3569fd;
    }
    .creatbtn{
        width: 132px;
        height: 42px;
        background-color: #f7f9fc;
        border-radius: 4px;
        color: #3569fd;
        font-size: 16px;
        border: none;
        margin-bottom: 20px;
    }
    .inputDiv{
        width: 19%;
        display: inline-block;
    }
</style>


